var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-wishlist" },
    [
      _c("shop-headline", {
        attrs: { headline: _vm.$t("wishlist.wishlist"), icon: "star" },
      }),
      _vm._v(" "),
      _vm.isEmpty
        ? [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.$t("wishlist.isEmpty")) },
            }),
          ]
        : [
            !_vm.authenticated
              ? _c(
                  "shop-section",
                  [
                    _c(
                      "shop-login",
                      { attrs: { buttons: _vm.buttons } },
                      [
                        [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("wishlist.login.body")),
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.wishlistData.items, function (section, sectionIndex) {
              return [
                _c(
                  "div",
                  { attrs: { id: section.category } },
                  [
                    _c(
                      "h2",
                      { staticClass: "headline-2" },
                      [
                        _c("span", [_vm._v(_vm._s(section.sectionTitle))]),
                        _vm._v(" "),
                        section.category === "products" &&
                        _vm.showRoomdesignerButton(sectionIndex)
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "button-wrapper fill--xs spacer--top-none right",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button button--primary icon--before icon--roomdesigner",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRoomdesigner(
                                            sectionIndex
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("wishlist.toRoomDesigner")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    section.howToOrder
                      ? _c("div", [
                          _c("p", [_vm._v(_vm._s(section.howToOrder))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    section.category === "decorset"
                      ? [
                          _vm._l(
                            section.items,
                            function (decorset, decorsetIndex) {
                              return [
                                _c("div", { staticClass: "row global-edit" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-6" },
                                    [
                                      _vm.edit.sectionIndex === sectionIndex &&
                                      _vm.edit.decorsetIndex === decorsetIndex
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "global-edit--edit",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "global-edit--form form__input--with-button",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.edit.inputvalue,
                                                        expression:
                                                          "edit.inputvalue",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form__input form__input--text",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value:
                                                        _vm.edit.inputvalue,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.edit,
                                                          "inputvalue",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("button", {
                                                    staticClass:
                                                      "button button--secondary button--icon icon--before icon--close",
                                                    attrs: {
                                                      "aria-label": "discard",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.decorsetCloseEdit,
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button button--ghost icon--before icon--save",
                                                  on: {
                                                    click: _vm.decorsetSaveEdit,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("wishlist.save")
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "global-edit--editable",
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "headline headline--center-v headline--editable",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(decorset.name) +
                                                      "\n                                            "
                                                  ),
                                                  _c("button", {
                                                    staticClass:
                                                      "button button--secondary button--icon icon--before icon--edit icon--small",
                                                    attrs: {
                                                      "aria-label": "edit",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.decorsetOpenEdit(
                                                          decorset,
                                                          sectionIndex,
                                                          decorsetIndex
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-6" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "button-wrapper spaced right",
                                        },
                                        [
                                          _vm.showRoomdesignerButton(
                                            sectionIndex,
                                            decorsetIndex
                                          )
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button button--primary icon--before icon--roomdesigner",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openRoomdesigner(
                                                        sectionIndex,
                                                        decorsetIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "wishlist.toRoomDesigner"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("button", {
                                            staticClass:
                                              "button button--secondary button--icon icon--before icon--trash",
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(
                                                  decorset,
                                                  sectionIndex,
                                                  decorsetIndex
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row shop-wishlist__decorset",
                                  },
                                  [
                                    _vm._l(decorset.decors, function (decor) {
                                      return [
                                        _c("global-inline-tile", {
                                          staticClass:
                                            "col-6 col-md-4 col-lg-3",
                                          attrs: {
                                            image: decor.image_src,
                                            "image-link": decor.detail_link,
                                            title: "<b>" + decor.title + "</b>",
                                            subtitle: decor.subtitle,
                                          },
                                        }),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            }
                          ),
                        ]
                      : section.category === "product_samples"
                      ? [
                          _c("PimProductTableListSamples", {
                            attrs: { samples: section.items },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function (actionProps) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "button-wrapper spaced v-center right",
                                        },
                                        [
                                          _c("CartButton", {
                                            attrs: { entity: actionProps.item },
                                          }),
                                          _vm._v(" "),
                                          _c("button", {
                                            staticClass:
                                              "button button--secondary button--icon icon--before icon--trash",
                                            attrs: {
                                              title: _vm.$t("wishlist.remove"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(
                                                  actionProps.item,
                                                  sectionIndex,
                                                  actionProps.index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      : section.category === "material_samples"
                      ? [
                          _c("PimProductTableListInformationMaterial", {
                            attrs: { materials: section.items },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function (actionProps) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "button-wrapper spaced v-center right",
                                        },
                                        [
                                          _c("CartButton", {
                                            attrs: { entity: actionProps.item },
                                          }),
                                          _vm._v(" "),
                                          _c("button", {
                                            staticClass:
                                              "button button--secondary button--icon icon--before icon--trash",
                                            attrs: {
                                              title: _vm.$t("wishlist.remove"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(
                                                  actionProps.item,
                                                  sectionIndex,
                                                  actionProps.index
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      : section.category === "products"
                      ? [
                          _c("PimProductTableListProducts", {
                            attrs: { products: section.items },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function (actionProps) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "button-wrapper spaced v-center right",
                                        },
                                        [
                                          _c("button", {
                                            staticClass:
                                              "button button--secondary button--icon icon--before icon--trash",
                                            attrs: {
                                              title: _vm.$t("wishlist.remove"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(
                                                  actionProps.item,
                                                  sectionIndex,
                                                  actionProps.index
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      : [
                          _vm._v(
                            "\n                        Unsupported Section:"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                        " +
                              _vm._s(section) +
                              "\n                    "
                          ),
                        ],
                  ],
                  2
                ),
              ]
            }),
          ],
      _vm._v(" "),
      _vm.roomdesignerModalData
        ? _c("global-roomdesigner-selection", {
            attrs: { "initial-data": _vm.roomdesignerModalData },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }